import { useQuery } from "@tanstack/react-query";
import { useAccountID } from "./account";
import axios from "axios";

export const useCurrentPlan = () => {
    const accountID = useAccountID();
    return useQuery({
        queryKey: ["plan", accountID],
        queryFn: () => axios.get(`/api/${accountID}/plan`).then(res => res.data)
    });
};
